/*
    General JS
*/
document.querySelectorAll("#navbar-desktop .dropdown-toggle").forEach((e) => {
  const t = () => {
    document.querySelector("#navbar-desktop .dropdown-menu.show")
      ? document.querySelector("#main").classList.add("main-hidden")
      : document.querySelector("#main").classList.remove("main-hidden");
  };
  e.addEventListener("shown.bs.dropdown", t),
    e.addEventListener("hidden.bs.dropdown", t);
}),
  document
    .querySelectorAll("#navbar-desktop.menu-desktop-hover .nav-item.dropdown")
    .forEach((e) => {
      const t = bootstrap.Dropdown.getOrCreateInstance(
        e.querySelector(".nav-link")
      );
      e.addEventListener("mouseover", () => {
        document
          .querySelectorAll("#navbar-desktop.menu-desktop-hover .dropdown-menu")
          .forEach((t) => {
            t.previousElementSibling.dataset.index !==
              e.querySelector(".nav-link").dataset.index &&
              t.classList.remove("show");
          }),
          t.show();
      }),
        e.addEventListener("mouseleave", () => {
          setTimeout(() => {
            e.matches(":hover") || t.hide();
          }, 200);
        });
    }),
  (window.updateAtcPrice = () => {
    const atcPriceWrapper = document.querySelector('.btn-atc-price-wrapper');
    if (!atcPriceWrapper) return;

    const qtyInput = document.querySelector('[name="quantity"]');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    const basePrice = parseInt(atcPriceWrapper.dataset.basePrice, 10);
    const totalPrice = basePrice * quantity;

    const atcPrice = atcPriceWrapper.querySelector('.btn-atc-price');
    const moneyFormat = atcPriceWrapper.dataset.moneyFormat;
    if (atcPrice && moneyFormat) {
      atcPrice.innerHTML = Shopify.formatMoney(totalPrice, moneyFormat);
    }
  }),
  (window.onClickQtyPlusMinusProduct = (e) => {
    const t = e.closest(".quantity-wrapper").querySelector("input"),
      o = Number(t.value);
    "plus" === e.dataset.mode
      ? (t.value = o + 1)
      : t.value > Number(t.dataset.minQty) && (t.value = o - 1);
    const n = new Event("change");
    t.dispatchEvent(n);
    // Update price on ATC button
    if (typeof updateAtcPrice === 'function') {
        updateAtcPrice();
    }
  }),
  (window.onLinkShare = (e, t) => {
    if (navigator.share)
      navigator.share({
        title: e.dataset.shareTitle,
        url: window.location.href,
      });
    else {
      const t = bootstrap.Popover.getOrCreateInstance(e, {
        content: `\n <div class="input-group input-group-sm">\n <input type="text" class="form-control" value="${window.location.href}">\n <button id="btn-share-copy" class="btn btn-outline-secondary" type="button">${e.dataset.textCopy}</button>\n </div>\n `,
        html: !0,
        sanitize: !1,
        placement: "top",
      });
      t.show(),
        document
          .querySelector("#btn-share-copy")
          ?.addEventListener("click", (t) => {
            navigator.clipboard.writeText(window.location.href),
              (t.target.textContent = e.dataset.textCopied);
          }),
        setTimeout(() => {
          t.hide(), e.blur();
        }, 4e3);
    }
  });
const initSearchPageSetSelected = () => {
  const e = document.querySelector("#search-header .form-select");
  if (!e) return;
  const t = new URLSearchParams(location.search).get("type");
  t && (e.value = t);
};
initSearchPageSetSelected();
const initCountdownTimers = () => {
  document.querySelectorAll(".countdown-timer").forEach((e) => {
    if (e.classList.contains("init")) return;
    e.classList.add("init");
    let t = 1e3 * Number(e.dataset.time);
    t = Date.now() + 108e5;
    const o = 1e3,
      n = 6e4,
      a = 36e5,
      i = setInterval(() => {
        const s = new Date().getTime(),
          r = t - s;
        if (r < 0) return clearInterval(i), void e.remove();
        e.removeAttribute("hidden");
        const d = Math.floor(r / a),
          c = Math.floor((r % a) / n),
          l = Math.floor((r % n) / o);
        (e.querySelector("[data-hours").innerText = `${d}${e.dataset.textH}`),
          e
            .querySelector("[data-hours")
            .setAttribute("aria-label", `${d} ${e.dataset.textHours}`),
          (e.querySelector(
            "[data-minutes"
          ).innerText = `${c}${e.dataset.textM}`),
          e
            .querySelector("[data-minutes")
            .setAttribute("aria-label", `${c} ${e.dataset.textMinutes}`),
          (e.querySelector(
            "[data-seconds"
          ).innerText = `${l}${e.dataset.textS}`),
          e
            .querySelector("[data-seconds")
            .setAttribute("aria-label", `${l} ${e.dataset.textSeconds}`),
          0 === d &&
            e.querySelector("[data-hours").setAttribute("hidden", "hidden");
      }, o);
  });
};
initCountdownTimers(),
  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelector(".countdown-timer") && initCountdownTimers();
  });
const initSprBadges = () => {
  window.SPR?.initDomEls(), window.SPR?.loadBadges();
};
window.addEventListener("updated.theme.cart", initSprBadges),
  window.addEventListener("updated.theme.collection", initSprBadges),
  document.querySelector("#shopify-product-reviews") &&
    setInterval(() => {
      document
        .querySelector(".spr-summary-actions-newreview")
        .classList.add("btn", "btn-secondary"),
        document.querySelectorAll("input.spr-form-input").forEach((e) => {
          e.classList.add("form-control");
        }),
        document.querySelectorAll("textarea.spr-form-input").forEach((e) => {
          e.classList.add("form-control");
        });
    }, 2e3),
  document
    .querySelectorAll(".dropdown-megamenu .dropdown-item.active")
    .forEach((e) => {
      e.classList.remove("active");
    }),
  document
    .querySelectorAll("#offcanvas-menu .dropdown-item.active")
    .forEach((e) => {
      e.classList.remove("active");
    });

// 修复超级菜单中二级菜单点击问题
document.addEventListener("DOMContentLoaded", function () {
  // 为二级菜单的标题添加点击事件处理
  document
    .querySelectorAll(".dropdown-megamenu .col h6")
    .forEach(function (h6) {
      h6.addEventListener("click", function (event) {
        // 阻止事件冒泡到父元素
        event.stopPropagation();
        // 如果标题旁边有链接，模拟点击链接
        if (
          this.nextElementSibling &&
          this.nextElementSibling.tagName === "UL"
        ) {
          // 此标题是二级菜单分类，不做任何操作，只阻止冒泡
        }
      });
    });

  // 确保三级菜单项点击时不会触发父级菜单的点击事件
  document
    .querySelectorAll(".dropdown-megamenu .dropdown-item")
    .forEach(function (item) {
      item.addEventListener("click", function (event) {
        // 阻止事件冒泡，使链接正常工作
        event.stopPropagation();
      });
    });
});

const initPrevNextArticleButtons = async () => {
  const e = document.querySelector("#article-prev-next");
  if (!e) return;
  await new Promise((e) => setTimeout(e, 1e3));
  window.addEventListener("scroll", () => {
    window.scrollY > 600 ? e.classList.add("show") : e.classList.remove("show");
  });
};
initPrevNextArticleButtons();

document.addEventListener('change', (event) => {
    const productForm = event.target.closest('#product-form-main');
    if(productForm) {
        if (typeof updateAtcPrice === 'function') {
            const priceWrapper = document.querySelector('.btn-atc-price-wrapper');
            const newVariantIdInput = document.querySelector('#product-form-main input[name="id"]');

            if(priceWrapper && newVariantIdInput) {
                // Find the selected variant from the global variants object
                const newVariant = window.productVariants.find(v => v.id == newVariantIdInput.value);
                if (newVariant) {
                    priceWrapper.dataset.basePrice = newVariant.price;
                }
            }
            updateAtcPrice();
        }
    }
});
